'use client'

import { useEffect, useMemo, useState } from 'react'
import { InlineWidget, useCalendlyEventListener } from 'react-calendly'
import { Section } from '../../chrome/Section'
import { ButtonCTA } from '../../controls/ButtonCTA'
import { useClientMounted } from '../../hooks/use-client-mounted'
import { loadLeadMagnetQualification } from '../../utils/lead-magnet-qualification'
import { clearSchedulePrefill, loadCalendlyPrefill } from '../../utils/schedule-prefill'
import type { LeadMagnetPageWithScheduleCTA } from '../config'

type Props = { magnet: LeadMagnetPageWithScheduleCTA }

export function LeadMagnetSchedule({ magnet }: Props) {
  const [height, setHeight] = useState('500px')
  const mounted = useClientMounted()
  const showCalendly = mounted && loadLeadMagnetQualification()
  const prefill = useMemo(() => (mounted ? loadCalendlyPrefill() : undefined), [mounted])

  useEffect(() => () => clearSchedulePrefill(), [])

  useCalendlyEventListener({
    onPageHeightResize: (e) => {
      setHeight(e.data.payload.height)
    },
    onEventScheduled: () => {
      clearSchedulePrefill()
    },
  })

  return (
    <Section paddingY="xs" maxWidth="lg">
      <div className="flex flex-col items-center gap-8">
        {magnet.downloadLinks?.map((link) => (
          <ButtonCTA key={link.href} href={link.href} target="_blank" variant="cta-dark">
            {link.text}
          </ButtonCTA>
        ))}
        {magnet.downloadLink && (
          <ButtonCTA href={magnet.downloadLink} target="_blank" variant="cta-dark">
            Download the guide
          </ButtonCTA>
        )}
        {showCalendly && (
          <p className="text-title-sm font-semibold text-foreground">
            Want more help? Talk with one of our financial advisors.
          </p>
        )}
      </div>

      {mounted && showCalendly && (
        <InlineWidget
          url={magnet.calendlyUrl}
          className="mt-6 w-full tablet:mt-0"
          styles={{ height, minHeight: '500px' }}
          pageSettings={{ hideGdprBanner: true, hideLandingPageDetails: true }}
          prefill={prefill}
        />
      )}
    </Section>
  )
}
